"use client"

import * as React from "react"

import { cn } from "@/lib/utils"

interface AvatarGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

function AvatarGroup({ className, children, ...props }: AvatarGroupProps) {
  return (
    <div
      data-slot="avatar-group"
      className={cn(
        "flex -space-x-2 [&_[data-slot=avatar]]:ring-2 [&_[data-slot=avatar]]:ring-background",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

interface AvatarMoreProps extends React.HTMLAttributes<HTMLDivElement> {
  count: number
}

function AvatarMore({ count, className, ...props }: AvatarMoreProps) {
  return (
    <div
      data-slot="avatar"
      className={cn(
        "relative flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-muted text-muted-foreground text-xs font-medium",
        className
      )}
      {...props}
    >
      +{count}
    </div>
  )
}

export { AvatarGroup, AvatarMore }
